import { useStyles } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';
import { NavigationList, Accordion } from '@archipro-design/aria';
import { AddFill, CloseLine } from '@archipro-design/icons';
import type { AccordionTitleProps } from '@fluentui/react-northstar';
import { Link } from '@remix-run/react';
import type { AccordionSchema, SubfooterCategory } from '../../type';
import type { SubFooterProps } from './SubFooter';
import * as S from './SubFooter.style';
import { useLocation } from '@remix-run/react';
import { useEffect } from 'react';

export const SubFooterMobile = (props: SubFooterProps) => {
    const { categories } = props;
    const { css } = useStyles();
    const location = useLocation();

    useEffect(() => {
        if (location?.state?.scroll === true) {
            window?.scrollTo(0, 0);
        }
    }, [location?.state?.scroll]);

    return categories.length ? (
        <div className={css(S.SubFooterMobileStyle)}>
            <Accordion
                defaultActiveIndex={[0]}
                panels={
                    categories.map((category: SubfooterCategory, i) => ({
                        title: {
                            id: `${category.title}${i}id`,
                            key: `${category.title}${i}key`,
                            content: category.title,
                        },
                        content: {
                            content: (
                                <NavigationList
                                    items={category.items.map((item) => {
                                        return { as: Link, ...item };
                                    })}
                                    moreButton={{
                                        as: Link,
                                        ...category.moreButton,
                                        state: { scroll: true },
                                    }}
                                    variables={{
                                        optionMoreButtonGap: pxToRem(18),
                                        optionGap: pxToRem(16),
                                    }}
                                />
                            ),
                            id: `${i}id-content`,
                            key: `${i}id-key`,
                        },
                        key: `sub-footer-key${i}`,
                        id: `sub-footer-id${i}`,
                    })) as unknown as AccordionSchema[]
                }
                renderPanelTitle={(
                    Component,
                    itemProps: AccordionTitleProps
                ) => (
                    <Component
                        indicator={
                            itemProps.active ? (
                                <CloseLine
                                    variables={{
                                        '1xSize': pxToRem(18),
                                    }}
                                />
                            ) : (
                                <AddFill
                                    variables={{
                                        '1xSize': pxToRem(18),
                                    }}
                                />
                            )
                        }
                        {...itemProps}
                        key={'subfooter-section-panel-title' + itemProps.index}
                    />
                )}
            />
        </div>
    ) : null;
};
